module.exports = __webpack_public_path__ + "img/down.7b2dd554.png";